<!-- case skeleton -->
@if(this.lineupsService.isLoadingMatchStats()) {
<app-skeleton-match-lineups />
}

<!-- case error or no data-->
@if(!this.lineupsService.isLoadingMatchStats() && (!this.hasData() ||
this.lineupsService.isErrorMatchStats()) ) {
<app-no-result message="NotAvalaibleInformation" />
}

<!-- case data -->
@if(!this.lineupsService.isLoadingMatchStats() &&
this.lineupsService.matchLineups() && this.hasData()) {
<div class="stadium-container">
  <div class="stadium-inner" [class.rotated]="isMobile()">
    <!-- Jugadores -->
    @if(homePlayersInTheField().length> 0 && awayPlayersInTheField().length> 0){
    <!-- Imagen horizontal (desktop) -->
    <img
      [src]="stadiumImg"
      alt="Cancha horizontal"
      class="stadium-img desktop"
    />

    <!-- Imagen vertical (mobile) -->
    <img
      [src]="stadiumVerticalImg"
      alt="Cancha vertical"
      class="stadium-img mobile"
    />

    <!-- Jugadores locales -->
    @for (player of homePlayersInTheField(); track $index) {
    <div
      class="absolute flex items-center justify-center"
      [ngStyle]="getPlayerPosition(player, true)"
    >
      <div class="relative flex flex-col items-center justify-center">
        <img
          src="{{ getImagePlayer(player.Photo) }}"
          class="player-img"
          alt="{{ getShortName(player) }}"
        />
        <div
          class="absolute min-w-14 top-3/4 px-1.5 py-1 rounded-5 flex flex-col items-center justify-center bg-gradient-to-b from-[#2C0000] to-[#BF4040]"
        >
          <div class="font-bold text-white leading-none player-text">
            {{ player.Number }}
          </div>
          <div
            class="font-bold text-white text-nowrap leading-none player-text"
          >
            {{ getShortName(player) }}
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Jugadores visitantes -->
    @for (player of awayPlayersInTheField(); track $index) {
    <div
      class="absolute flex items-center justify-center"
      [ngStyle]="getPlayerPosition(player, false)"
    >
      <div class="relative flex flex-col items-center justify-center">
        <img
          src="{{ getImagePlayer(player.Photo) }}"
          class="player-img"
          alt="{{ getShortName(player) }}"
        />
        <div
          class="absolute top-3/4 px-1.5 py-1 rounded-5 flex flex-col items-center justify-center bg-gradient-to-b from-[#161616] to-[#313131]"
        >
          <div class="font-bold text-white leading-none player-text">
            {{ player.Number }}
          </div>
          <div
            class="font-bold text-white text-nowrap leading-none player-text"
          >
            {{ getShortName(player) }}
          </div>
        </div>
      </div>
    </div>
    } }
  </div>
</div>

<div class="flex flex-col gap-5">
  <!-- has at least one of the team's substitute players -->
  @if(this.hasSubstitutePlayers()) {
  <app-lineup-players-group
    [homeLineUp]="
      this.lineupsService.matchLineups()!.HomeLineup.Substitutes || []
    "
    [awayLineUp]="
      this.lineupsService.matchLineups()!.AwayLineup.Substitutes || []
    "
    [title]="'Substitute' | translate"
  />
  }
  <!-- has at least one of the team's missing players -->
  @if(this.hasMissingPlayers()) {
  <app-lineup-players-group
    [homeLineUp]="this.lineupsService.matchLineups()!.HomeLineup.Missing || []"
    [awayLineUp]="this.lineupsService.matchLineups()!.AwayLineup.Missing || []"
    [title]="'MissingPlayers' | translate"
  />
  }
  <!-- has at least one of the team's coach -->
  @if(this.hasCoaches()) {
  <app-lineup-coachs-group
    [homeCoach]="this.lineupsService.matchLineups()!.HomeLineup.Coach"
    [awayCoach]="this.lineupsService.matchLineups()!.AwayLineup.Coach"
    [title]="'Coachs' | translate"
  />
  }
</div>
}

<!--
<div class="flex flex-col gap-5">
   has at least one of the team's starting players
  @if(this.hasStartingPlayers()) {
  <app-lineup-players-group
    [homeLineUp]="this.lineupsService.matchLineups()!.HomeLineup.Starting || []"
    [awayLineUp]="this.lineupsService.matchLineups()!.AwayLineup.Starting || []"
    [title]="'StartingLineups' | translate"
  />
  }

   has at least one of the team's substitute players
  @if(this.hasSubstitutePlayers()) {
  <app-lineup-players-group
    [homeLineUp]="
      this.lineupsService.matchLineups()!.HomeLineup.Substitutes || []
    "
    [awayLineUp]="
      this.lineupsService.matchLineups()!.AwayLineup.Substitutes || []
    "
    [title]="'Substitute' | translate"
  />
  }

   has at least one of the team's missing players
  @if(this.hasMissingPlayers()) {
  <app-lineup-players-group
    [homeLineUp]="this.lineupsService.matchLineups()!.HomeLineup.Missing || []"
    [awayLineUp]="this.lineupsService.matchLineups()!.AwayLineup.Missing || []"
    [title]="'MissingPlayers' | translate"
  />
  }

   has at least one of the team's coach
  @if(this.hasCoaches()) {
  <app-lineup-coachs-group
    [homeCoach]="this.lineupsService.matchLineups()!.HomeLineup.Coach"
    [awayCoach]="this.lineupsService.matchLineups()!.AwayLineup.Coach"
    [title]="'Coachs' | translate"
  />
  }
</div> -->
